
import { IMenuModel } from "src/model";

export default class State
{
    /**
     * 获取或设置accessToken。
     * @member
     * @returns string
     */
    public accessToken: string = "";

    /**
     * 获取或设置refreshtoken
     * @member
     * @returns string
     */
    public refreshtoken: string = "";

    /**
     * 获取或设置店铺id
     * @member
     * @returns number
     */
    public tenantId: number;

    /**
     * 获取或设置accessToken。
     * @member
     * @returns string
     */
    public menuData: Array<IMenuModel> = [];

    /**
     * 用户信息
     * @member
     * @returns any
     */
    public userInfo: any;

    /**
     * 获取或设置。
     * @member
     * @returns number
     */
    public isLogin: number = 0;
    
}
